const CreateEvaluationIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14 10.83H10.83V14H9.17V10.83H6V9.17H9.17V6H10.83V9.17H14V10.83Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

export default CreateEvaluationIcon;
